import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ControlContainer, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-dados-inscricao',
    standalone: true,
    imports: [ReactiveFormsModule, Select],
    templateUrl: './dados-inscricao.html',
    styleUrl: './dados-inscricao.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção de formulário de dados de inscrição. */
export class DadosInscricaoComponent {
    modoEdicao = input<boolean>(false);
    opcoesTipoInscricao = input<{ label: string; value: string | number | boolean | null }[]>([]);
    opcoesSituacao = input<{ label: string; value: string | number | boolean | null }[]>([]);
    carregandoDominios = input<boolean>(false);
    formValid = input<boolean>(true);
    acoesDesabilitadas = input<boolean>(false);

    onSaveChanges = output<void>();
    onCancelChanges = output<void>();
    onEdit = output<void>();

    // Helper para acessar o form group injetado se necessário, mas no template o formControlName funciona direto
    constructor(public formGroupDirective: FormGroupDirective) {}

    get form(): FormGroup {
        return this.formGroupDirective.form;
    }
}
